<div class="instruction-editor" [class.extra-margin-bottom]="addExtraMarginBottom" *ngIf="seoControl">
    <div class="left-panel" [class.full-width]="showLeftSide && !showRightSide" *ngIf="showLeftSide">
        <div class="label">
            <img [alt]="('attention' | transloco)" [title]="('attention' | transloco)"
                src="../../../../assets/icons/warning-icon.svg">
            <span>{{ 'attention' | transloco }}</span>
        </div>
        <p class="warning-msg">{{ seoControl.warning }}</p>
    </div>
    <div class="right-panel" [class.full-width]="showRightSide && !showLeftSide" *ngIf="showRightSide">
        <div class="label">
            <img [alt]="('approved-instruction' | transloco)" [title]="('approved-instruction' | transloco)"
                src="../../../../assets/icons/check-circle.svg">
            <span *ngIf="showRightSide && showLeftSide">{{ 'instruction-approved-by' | transloco }}</span>
            <span *ngIf="showRightSide && !showLeftSide">{{ 'page-content-editor' | transloco }}</span>
        </div>
        <div class="photo" [class.extra-margin-top]="showRightSide && !showLeftSide">
            <img [src]="(photoImages + 'png/' + seoControl.editor.photo) + '.png' | isImgNull"
                [title]="seoControl.editor.editorName" [alt]="seoControl.editor.editorName">
        </div>
        <div class="text">
            <p class="name">{{ seoControl.editor.editorName }}</p>
            <p class="description">{{ seoControl.editor.description }}</p>
        </div>
    </div>
</div>